/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Upload16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M14.5 15a.5.5 0 010 1h-13a.5.5 0 010-1h13zM7.22 1.375c.4-.5 1.16-.5 1.56 0l4 5A.999.999 0 0112 8H9.995l-.009 4.002a1 1 0 01-1 .998H7a1 1 0 01-1-1v-.002L6.008 8H4a1 1 0 01-.846-1.534l.065-.09z"
        />
    </AccessibleSVG>
);

export default Upload16;
